import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

const AdminPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f5f3ff',
      100: '#ede9fe',
      200: '#ddd6fe',
      300: '#c4b5fd',
      400: '#a78bfa',
      500: '#8b5cf6',
      600: '#7c3aed',
      700: '#6d28d9',
      800: '#5b21b6',
      900: '#4c1d95',
      950: '#1e1b4b',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#7c3aed',
          inverseColor: '#ffffff',
          hoverColor: '#6d28d9',
          activeColor: '#5b21b6',
        },
      },
    },
  },
})

export default AdminPreset
